/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ApiResponseLocalDateTime } from '../../models/api-response-local-date-time';

export interface GetLastLogin$Params {
  'x-api-requestId': string;
  'x-api-canal': string;
  companyId: string;
}

export function getLastLogin(http: HttpClient, rootUrl: string, params: GetLastLogin$Params, context?: HttpContext): Observable<StrictHttpResponse<ApiResponseLocalDateTime>> {
  const rb = new RequestBuilder(rootUrl, getLastLogin.PATH, 'get');
  if (params) {
    rb.header('x-api-requestId', params['x-api-requestId'], {});
    rb.header('x-api-canal', params['x-api-canal'], {});
    rb.path('companyId', params.companyId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ApiResponseLocalDateTime>;
    })
  );
}

getLastLogin.PATH = '/v1/api/ui/company/last-login/{companyId}';
